import { useEffect, useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Action from 'ageas-react-component-action'
import MainLoader from 'ageas-react-component-loader'

import { AnimalDataRow } from '../../Components/AdditionalRiskData/AnimalDataRow'
import { Tooltip } from '../../Components/Tooltip'
import { MainContainer } from '../../GlobalStyles'
import { useAnimalStore } from '../../Stores/animalStore'
import { useProgressStore } from '../../Stores/progressStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { useWarningStore } from '../../Stores/warningStore'
import { ROUTES } from '../../constants/routes'
import { useSubmitPetsInfo } from '../../hooks/api/submitPetsInfo/useSubmitPetsInfo'
import { useSubmitPetsInfoPayload } from '../../hooks/api/submitPetsInfo/useSubmitPetsInfoPayload'
import { t } from '../../i18n'
import {
  isAnimalOlderThan,
  validateNumberAndLetters,
} from '../../utils/validates'
import {
  ActionHeader,
  AnimalInsuranceListContainer,
  ButtonNextContainer,
  DataContainer,
  Header,
  Row,
  Table,
  TableContainer,
  Title,
} from './style'

export function AdditionalRiskData() {
  const navigate = useNavigate()
  const { setCurrentStep } = useProgressStore()
  const { animalsList } = useAnimalStore()
  const { setWarningOptions } = useWarningStore()
  const { submitPetsInfoPayload } = useSubmitPetsInfoPayload()
  const { isGenerateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { isLoading, isSuccess, mutate } = useSubmitPetsInfo()
  const { disabledStepsByResume } = useResumeStore()
  const [formValidity, setFormValidity] = useState(false)
  const [animalGenderValidate, setAnimalGenderValidate] = useState(false)
  const [isBaby, setIsBaby] = useState(false)

  useEffect(() => {
    if (isSuccess) {
      navigate(ROUTES.summaryConditions)
    }
  }, [isSuccess, navigate])

  let label = ''
  useEffect(() => {
    const isFormValid = animalsList.every((animal) => {
      const isOlderThan120 = isAnimalOlderThan(animal, 120)

      const isValid = isOlderThan120
        ? (animal.gender || '')?.length > 0 &&
          (validateNumberAndLetters(animal.licenseNumber || '') ||
            validateNumberAndLetters(animal.chipNumber || ''))
        : (animal.gender || '')?.length > 0

      if (!isValid) {
        label += t('pages.step4.validationLabel', { name: animal.name })
        if (
          isOlderThan120 &&
          (animal.gender || '')?.length > 0 &&
          ((animal.licenseNumber || '').length === 0 ||
            (animal?.chipNumber || '')?.length === 0)
        ) {
          label += 'erro' + ', '
        }
        if (isOlderThan120 && (animal?.chipNumber || '')?.length === 0) {
          label += t('pages.step4.chipNumber') + ', '
        }
        if (isOlderThan120 && !animal.gender) {
          label += t('pages.step4.gender') + '. '
        }

        if (!isOlderThan120) {
          label += t('pages.step4.gender')
        }
      }
      return isValid
    })
    setFormValidity(isFormValid)
  }, [animalsList])

  useEffect(() => {
    setAnimalGenderValidate(
      animalsList.every((animal) => (animal.gender || '')?.length > 0),
    )
    setIsBaby(animalsList.every((animal) => !isAnimalOlderThan(animal, 120)))
  }, [animalsList])

  function handleClickContinueButton() {
    if (formValidity) {
      mutate(submitPetsInfoPayload)
    } else {
      setWarningOptions({
        labelTypes: [label],
      })
    }
  }

  useLayoutEffect(() => {
    setCurrentStep(4)
  }, [setCurrentStep])

  return (
    <>
      <MainContainer>
        <MainLoader show={isLoading} />
        <DataContainer>
          <AnimalInsuranceListContainer>
            <Title>{t('pages.step4.table.title')}</Title>
            <TableContainer>
              <Table>
                <tbody>
                  <Row>
                    <Header>{t('table.name')}</Header>
                    <Header>{t('table.birthday')}</Header>
                    <Header>{t('table.pack')}</Header>
                    <Header>{t('table.breed')}</Header>
                    <ActionHeader></ActionHeader>
                  </Row>
                  {/* secured animal  list */}
                  {animalsList.map((animal) => (
                    <AnimalDataRow
                      key={`animal-data-${animal.id}-${animal.name}`}
                      animal={animal}
                    />
                  ))}
                </tbody>
              </Table>
            </TableContainer>
            <ButtonNextContainer>
              <Tooltip
                maxWidth="300px"
                id="footerInfo"
                text={t('pages.step4.toolTipMandatoryField', {
                  hasGender: !animalGenderValidate
                    ? t('pages.step4.genderAnimal')
                    : '',
                })}
                hidden={isBaby || formValidity}
              >
                <div className="button-action">
                  <Action
                    id="step4Continue"
                    disable={
                      isLoading ||
                      !formValidity ||
                      isGenerateProposalDocuments ||
                      disabledStepsByResume.step4
                    }
                    label={t('general.continue')}
                    type="button"
                    onValueChanged={() => handleClickContinueButton()}
                  />
                </div>
              </Tooltip>
            </ButtonNextContainer>
          </AnimalInsuranceListContainer>
        </DataContainer>
      </MainContainer>
    </>
  )
}
